import React, { useContext, useEffect, useState } from 'react';
import { MenuItem, Select } from '@material-ui/core';

import { warehouseApi as api } from 'api/warehouse';

function FacilityPicker({
    activeOnly = false,
    defaultValue = '',
    inactiveDisabled = false,
    onChange,
    selectStyle = {},
    whitelistedFacilities = null,
}) {
    const [facilities, setFacilities] = useState([]);
    const [facilityID, setFacilityID] = useState(defaultValue);

    const getFacilities = async () => {
        const res = await api.getFacilities(activeOnly);
        if (res.status !== true) {
            return;
        }

        let fac = res.data.rows.map((item) => ({
            text: item.name,
            value: item.id,
            active: item.active,
            lineSlot4000s: item.lineSlot4000s,
            caseMovements: item.caseMovements,
        }));
        if (!!whitelistedFacilities && whitelistedFacilities.length > 0) {
            fac = fac.filter((item) => whitelistedFacilities.includes(item.value));
        }
        setFacilities(fac);
    };

    useEffect(() => {
        if (onChange && onChange instanceof Function) {
            const facility = facilities.find((item) => item.value === facilityID);
            onChange(facilityID, facility?.text, facility);
        }
    }, [facilityID, facilities]);

    useEffect(() => {
        getFacilities();
    }, []);

    useEffect(() => {
        setFacilityID(defaultValue);
    }, [defaultValue]);

    const defaultSelectStyle = {
        minWidth: 80,
        width: 'auto',
        marginLeft: 8,
        marginRight: 8,
        ...selectStyle,
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <h2 style={{ margin: 0, marginRight: 8 }}>Facility</h2>
            <Select
                id="Facility_select"
                style={defaultSelectStyle}
                value={facilityID}
                variant="outlined"
                onChange={(event) => {
                    setFacilityID(event.target.value);
                }}
            >
                {facilities.map((item) => (
                    <MenuItem disabled={inactiveDisabled && !item.active} key={item.value} value={item.value}>
                        {item.text}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
}

export { FacilityPicker };
